export const dateRangePicker = {
  flex: 1,
  minWidth: 0,
} as const;

export const underlineStyle = {
  visibility: "hidden",
} as const;
